import HeroSimple from './HeroSimple'
export default HeroSimple
